import React from "react";
import { Play } from "lucide-react";
import { track } from "@/lib/analytics";

export const spotifySearchUrl = (artist, title) => `https://open.spotify.com/search/${encodeURIComponent(`${title} ${artist}`)}`;

export const ListenButton = ({ artist, title, dark = false, label = false, testid }) => (
  <a
    href={spotifySearchUrl(artist, title)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    onClick={(e) => { e.stopPropagation(); track("listen_spotify", { category: "number_ones", title }); }}
    aria-label={`Listen to ${title} by ${artist} on Spotify`}
    title="Listen on Spotify"
    className={`inline-flex items-center justify-center gap-1.5 shrink-0 rounded-full border transition-colors ${label ? "h-8 px-3 text-[12px] font-semibold" : "w-7 h-7"} ${dark ? "border-white/20 text-white/70 hover:border-[#1DB954] hover:text-[#1DB954]" : "border-[#e5e7eb] bg-white text-ink-muted hover:border-[#1DB954] hover:text-[#1DB954]"}`}
  >
    <Play className="w-3.5 h-3.5 fill-current" />{label && "Listen"}
  </a>
);
